import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import {
  Play,
  Film,
  Camera,
  ArrowRight,
  Menu,
  X,
  Instagram,
  Facebook,
  Mail,
  Phone,
  MapPin,
  ChevronDown,
  Video,
  Image as ImageIcon,
  Palette,
  Share2,
  Scissors,
  Lightbulb,
  Search,
  PenTool,
  Clapperboard,
  CheckCircle,
  Rocket,
  Users,
  Award,
  Clock,
  Target,
  Zap
} from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_design-upgrade-122/artifacts/ypzz64re_BV%20Creative%20Group%20%282%29.png";

// Dropbox Base URL helper - converts to direct link
const getDropboxDirectUrl = (url) => url.replace('dl=0', 'raw=1');

// All Videos from Dropbox (21 total)
const allVideos = [
  { id: 1, title: "Brand Campaign 1", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AJGXykAHSvNe3sgNOdeHs1k/1.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 2, title: "Brand Campaign 2", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/ABwcMxpmoNNOjN8J-TOgG9I/2.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 3, title: "Brand Campaign 3", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/ALKNzE_a7fX_pK7mlNDpc08/3.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 4, title: "Brand Campaign 4", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AHG1XCSDm8VCCmh_wWj2Drg/4.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 5, title: "Brand Campaign 5", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AD76VimkIyOCZEuVHKamJRQ/5.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 6, title: "Brand Campaign 6", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AI5BrlYxVeki78BfvAalkjM/6.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 7, title: "Brand Campaign 7", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AEyDzKfNIwGv9OX34Wy2rJI/7.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 8, title: "Brand Campaign 8", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AEacNX288Aq15-cDCOkRolw/8.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 9, title: "Brand Campaign 9", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/ALRB_0eDf-R7Y7pPiq9_xFE/9.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 10, title: "Brand Campaign 10", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/ACjPGje2o6zPm2GwkKy16qQ/10.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 11, title: "Brand Campaign 11", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/APK0FKMMeIKj6GbkfVqJhr8/11.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 12, title: "Brand Campaign 12", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AGG-3BGv8dEY5sT7XDyCUVo/12.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 13, title: "Brand Campaign 13", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/APvbssyZPw502AHFm8bXYs8/13.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 14, title: "Brand Campaign 14", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AG2YeX1DcBZQBrQq8lwD6VQ/14.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 15, title: "Brand Campaign 15", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AB8U8I-gJvbg1KBNOo11ztI/15.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 16, title: "Brand Campaign 16", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/ABAT2pLMKDW9CbnhW4zeT6Y/16.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 17, title: "Brand Campaign 17", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AMKLfZdg8JDBIvx4uR8Tr0I/17.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 18, title: "Brand Campaign 18", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AEF0_JbL-zQrpiGVR4CQt_s/18.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 19, title: "Brand Campaign 19", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AIVoEBtXrZ7mLXr6gtS73kU/19.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 20, title: "Brand Campaign 20", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AAkSeRFgM68w1VC8Z0uTjQY/20.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
  { id: 21, title: "Brand Campaign 21", src: "https://www.dropbox.com/scl/fo/jp83kz120l518gn61thth/AL2WOa2OFKlJW4otkJybViQ/21.mp4?rlkey=uw7k8t7m65fgi7grksh40kn5l&raw=1" },
];

// All Images from Dropbox (16 total)
const allImages = [
  { id: 1, title: "Creative Design C22", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/ANrFmQ99viYTBq2gjKpbo-U/C22.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 2, title: "Creative Design C46", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/ANN37N7V5P6ButMbxhnvH_o/C46.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 3, title: "Car Feature 1", category: "Automotive", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AI4rgYiIsoX29UElBjVLA-8/CAR%20FEATURE%20%281%29.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 4, title: "Car Feature", category: "Automotive", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AIkFa2AfgVgfaZKVbC-CiPU/CAR%20FEATURE.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 5, title: "FN Design 2", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/ABAJgLBOWVYpAc5hZb9czbQ/FN%20%282%29.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 6, title: "FN Design", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/ANrXmyxadLhRTI4M3WinPIM/FN.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 7, title: "Hillhon Campaign", category: "Automotive", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AG8xa7lBANd7XpCTnsPCeHw/HILLHON.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 8, title: "Hilltoy Campaign", category: "Automotive", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AI9NI3Ui0Ea2ypUFoWjvdpY/HILLTOY.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 9, title: "Honman Design 1", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/ANbWqqz1jrbsTpC2LTqugpo/HONMAN%20%281%29.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 10, title: "Honman Design", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AC5IgQdhQAd19Igeei3t_M0/HONMAN.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 11, title: "LH 2026 Campaign", category: "Automotive", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AJpok_JvhbHYOxYSZL5hizM/LH%202026.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 12, title: "LR10 Design", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AADUQ8ASvD2i37FyfAmhfFg/LR10.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 13, title: "MAB Campaign", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AAxnOtOqs0jdT7wC44DI4XI/MAB.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 14, title: "NOQ Design", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AM1VMsh9R_K24BLdCHjw29A/NOQ.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 15, title: "NOSI Design", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AF5vQi8ic73ysCCmp_xmHhI/NOSI.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
  { id: 16, title: "QAM Campaign", category: "Creative", src: "https://www.dropbox.com/scl/fo/wskqj0rjacqu88bba28oz/AIogZAsvrrKF4sRoqfqCgKk/QAM.png?rlkey=zb64lp3bojxg7gy1ryjsc6eod&raw=1" },
];

// Function to get weekly rotation - selects different items each week
const getWeeklyContent = (items, count) => {
  const weekNumber = Math.floor(Date.now() / (7 * 24 * 60 * 60 * 1000));
  const startIndex = (weekNumber * count) % items.length;
  const result = [];
  for (let i = 0; i < count; i++) {
    result.push(items[(startIndex + i) % items.length]);
  }
  return result;
};

// Get 8 videos and 8 images for this week
const galleryVideos = getWeeklyContent(allVideos, 8);
const galleryImages = getWeeklyContent(allImages, 8).map((img, index) => ({
  ...img,
  span: index === 0 ? "col-span-12 md:col-span-8 row-span-2" : 
        index < 3 ? "col-span-12 md:col-span-4 row-span-1" :
        index === 3 ? "col-span-12 md:col-span-4 row-span-2" :
        "col-span-12 md:col-span-4 row-span-1"
}));

// 6 Core Services
const services = [
  {
    icon: Video,
    title: "Video Production",
    description: "Cinematic storytelling and commercial-grade production for brand campaigns, social platforms, and digital marketing."
  },
  {
    icon: Camera,
    title: "Photography",
    description: "Clean, modern, high-quality visuals for lifestyle, product, automotive, corporate, and events."
  },
  {
    icon: Palette,
    title: "Creative Design",
    description: "Social media graphics, campaign visuals, and marketing collateral built to capture attention."
  },
  {
    icon: Share2,
    title: "Social Media Management",
    description: "Full-scale content planning, scheduling, publishing, and platform management."
  },
  {
    icon: Scissors,
    title: "Post-Production",
    description: "Refined edits, advanced color grading, motion graphics, and social-first repurposing."
  },
  {
    icon: Lightbulb,
    title: "Strategic Planning",
    description: "Integrated content strategy, campaign architecture, and platform optimization for growth."
  }
];

// 5-Step Approach
const approachSteps = [
  { icon: Search, title: "Discovery", description: "We immerse in your brand's goals, audience, and positioning." },
  { icon: PenTool, title: "Concept & Strategy", description: "We craft a direction that aligns creative output with business objectives." },
  { icon: Clapperboard, title: "Production", description: "Our team captures, builds, and executes world-class visual content." },
  { icon: Scissors, title: "Post-Production", description: "Clean edits and finishing touches that deliver a professional look." },
  { icon: Rocket, title: "Deployment", description: "Seamless scheduling and publishing across your platforms." }
];

// Team roles
const teamRoles = [
  "Videographers & Photographers",
  "Creative Directors",
  "Video Editors & Post-Production Artists",
  "Graphic Designers",
  "Social Media Associates",
  "Strategic Planners"
];

const clients = ["LIFESTYLE", "AUTOMOTIVE", "CORPORATE", "PRODUCT", "EVENTS", "EDITORIAL"];

// Navigation Component
const Navigation = ({ isOpen, setIsOpen }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsOpen(false);
  };

  return (
    <nav
      data-testid="navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "nav-glass border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo - with fixed width to prevent distortion */}
          <Link to="/" data-testid="logo" className="flex items-center shrink-0">
            <img 
              src={LOGO_URL} 
              alt="BV Creative Group" 
              className="h-8 md:h-10 w-auto max-w-[140px] md:max-w-[160px] object-contain brightness-0 invert"
            />
          </Link>

          {/* Desktop Navigation - centered with proper spacing */}
          <div className="hidden md:flex items-center gap-8 lg:gap-10 ml-12">
            {["Home", "About", "Services", "Process", "Work", "Contact"].map((item) => (
              <button
                key={item}
                data-testid={`nav-${item.toLowerCase()}`}
                onClick={() => scrollToSection(item.toLowerCase() === "work" ? "gallery" : item.toLowerCase())}
                className="font-dm text-sm uppercase tracking-widest text-white/70 hover:text-white transition-colors duration-300 whitespace-nowrap"
              >
                {item}
              </button>
            ))}
          </div>

          {/* Get Quote Button - proper styling */}
          <button
            data-testid="nav-cta"
            onClick={() => scrollToSection("contact")}
            className="hidden md:flex items-center justify-center bg-white text-black px-5 py-2.5 font-dm font-bold text-xs uppercase tracking-wider hover:bg-white/90 transition-colors duration-300 rounded-full whitespace-nowrap ml-8"
          >
            Get Quote
          </button>

          {/* Mobile Menu Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden nav-glass border-t border-white/5"
          >
            <div className="px-6 py-8 flex flex-col gap-6">
              {["Home", "About", "Services", "Process", "Work", "Contact"].map((item) => (
                <button
                  key={item}
                  data-testid={`mobile-nav-${item.toLowerCase()}`}
                  onClick={() => scrollToSection(item.toLowerCase() === "work" ? "gallery" : item.toLowerCase())}
                  className="font-garet text-2xl uppercase tracking-wider text-white/70 hover:text-white transition-colors text-left"
                >
                  {item}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

// Hero Section
const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative h-screen flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1764693756664-769420e4ad6e?w=1920&q=80"
          alt="Red Luxury Sports Car"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" />
        <div className="absolute inset-0 bg-black/30" />
      </div>

      <div className="relative z-10 text-center px-6 w-full max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <p className="font-dm text-white/60 uppercase tracking-[0.3em] mb-6">
            Full-Service Creative Agency
          </p>
        </motion.div>

        {/* New Headline: We craft content that performs. */}
        <div className="overflow-hidden mb-4">
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <h1 className="font-garet text-5xl md:text-7xl lg:text-8xl font-bold italic uppercase leading-[0.9] tracking-tight">
              WE CRAFT CONTENT
            </h1>
          </motion.div>
        </div>
        
        <div className="overflow-hidden mb-10">
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
            className="flex flex-col md:flex-row items-center justify-center md:gap-4"
          >
            <span className="font-garet text-5xl md:text-7xl lg:text-8xl font-bold italic uppercase leading-[0.9] tracking-tight">
              THAT
            </span>
            <span className="font-garet text-5xl md:text-7xl lg:text-8xl font-bold italic uppercase leading-[0.9] tracking-tight neon-sweep pr-2">
              PERFORMS.
            </span>
          </motion.div>
        </div>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.0 }}
          className="font-dm text-white/60 text-lg md:text-xl max-w-3xl mx-auto mb-12"
        >
          High-impact video production, commercial photography, and end-to-end digital content systems designed for brands that want to lead.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.2 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <button
            data-testid="hero-cta-primary"
            onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })}
            className="btn-primary bg-white text-black px-8 py-4 font-dm font-bold uppercase tracking-widest hover:text-white transition-colors duration-300 rounded-full flex items-center justify-center gap-3"
          >
            Start Your Project
            <ArrowRight size={18} />
          </button>
          <button
            data-testid="hero-cta-secondary"
            onClick={() => document.getElementById("gallery").scrollIntoView({ behavior: "smooth" })}
            className="bg-transparent border border-white/20 text-white hover:border-white hover:bg-white/10 px-8 py-4 font-dm font-medium uppercase tracking-widest transition-all duration-300 rounded-full"
          >
            View Our Work
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
          className="flex flex-col items-center gap-2 text-white/40"
        >
          <span className="font-dm text-xs uppercase tracking-widest">Scroll</span>
          <ChevronDown size={20} />
        </motion.div>
      </motion.div>
    </section>
  );
};

// About Section
const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 px-6 md:px-12 bg-[#0A0A0A] relative overflow-hidden"
    >
      {/* Background Image with low opacity */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1920&q=80"
          alt="Creative Studio"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/90 to-[#0A0A0A]" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left - Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-dm text-[#E50914] uppercase tracking-[0.3em] mb-4">
              Who We Are
            </p>
            <h2 className="font-garet text-4xl md:text-6xl lg:text-7xl font-bold italic uppercase tracking-tight mb-8">
              <span className="text-stroke">25+ YEARS</span><br />OF EXCELLENCE
            </h2>
            <p className="font-dm text-white/70 text-lg leading-relaxed mb-6">
              A New York–based creative company built for brands that want to lead. We bring together filmmakers, photographers, editors, designers, and digital strategists to deliver content that performs.
            </p>
            <p className="font-dm text-white/50 leading-relaxed mb-8">
              From print advertising in 1999 to cutting-edge digital content today — we've evolved with the industry while staying true to our craft. Every asset we produce is guided by strategy, crafted with intention, and optimized for your brand's goals.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-center gap-3">
                <Award className="w-8 h-8 text-[#E50914]" />
                <div>
                  <p className="font-garet font-bold text-2xl">25+</p>
                  <p className="font-dm text-white/50 text-sm">Years Experience</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Users className="w-8 h-8 text-[#E50914]" />
                <div>
                  <p className="font-garet font-bold text-2xl">500+</p>
                  <p className="font-dm text-white/50 text-sm">Projects Delivered</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right - What Defines Us */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-6"
          >
            {[
              { icon: Zap, title: "Integrated Expertise", desc: "One company, multiple disciplines, unified output." },
              { icon: Target, title: "Brand-Forward Execution", desc: "Every asset supports your positioning and message." },
              { icon: Clock, title: "Consistent Workflow", desc: "From planning to publishing, we handle everything." },
              { icon: Award, title: "High Production Standards", desc: "Clean, cinematic, and campaign-ready content." }
            ].map((item, index) => (
              <div
                key={item.title}
                className="flex items-start gap-4 p-4 bg-white/5 border border-white/5 hover:border-white/20 transition-colors"
              >
                <item.icon className="w-6 h-6 text-[#E50914] mt-1 shrink-0" />
                <div>
                  <h4 className="font-garet font-bold uppercase mb-1">{item.title}</h4>
                  <p className="font-dm text-white/50 text-sm">{item.desc}</p>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Services Section
const Services = () => {
  const [activeService, setActiveService] = useState(0);

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 px-6 md:px-12 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="font-dm text-[#E50914] uppercase tracking-[0.3em] mb-4">
            Core Solutions
          </p>
          <h2 className="font-garet text-4xl md:text-6xl lg:text-7xl font-bold italic uppercase tracking-tight mb-6">
            <span className="text-stroke">OUR</span> SERVICES
          </h2>
          <p className="font-dm text-white/50 max-w-2xl mx-auto">
            End-to-end creative and digital solutions designed to elevate brand presence and drive meaningful engagement.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              data-testid={`service-${index}`}
              onMouseEnter={() => setActiveService(index)}
              className={`group cursor-pointer p-8 bg-[#0A0A0A] border border-white/5 hover:border-[#E50914]/50 transition-all duration-500 ${
                activeService === index ? "border-[#E50914]/50" : ""
              }`}
            >
              <service.icon className={`w-10 h-10 mb-6 transition-colors duration-300 ${
                activeService === index ? "text-[#E50914]" : "text-white/50 group-hover:text-[#E50914]"
              }`} />
              <h3 className="font-garet text-xl font-bold uppercase mb-3">
                {service.title}
              </h3>
              <p className="font-dm text-white/50 text-sm leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Our Approach / Process Section
const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32 px-6 md:px-12 bg-[#0A0A0A] relative noise-overlay"
    >
      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="font-dm text-[#E50914] uppercase tracking-[0.3em] mb-4">
            Our Approach
          </p>
          <h2 className="font-garet text-4xl md:text-6xl lg:text-7xl font-bold italic uppercase tracking-tight mb-6">
            <span className="text-stroke">STRATEGY</span> FIRST
          </h2>
          <p className="font-dm text-white/50 max-w-2xl mx-auto">
            Creativity next. Execution always. Here's how we bring your vision to life.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-5 gap-4">
          {approachSteps.map((step, index) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative group"
            >
              <div className="p-6 bg-[#121212] border border-white/5 hover:border-[#E50914]/30 transition-all duration-300 h-full">
                <div className="flex items-center gap-3 mb-4">
                  <span className="font-garet text-4xl font-bold text-[#E50914]/30">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <step.icon className="w-8 h-8 text-[#E50914] mb-4" />
                <h4 className="font-garet font-bold uppercase mb-2">{step.title}</h4>
                <p className="font-dm text-white/50 text-sm">{step.description}</p>
              </div>
              {index < approachSteps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-2 w-4 h-[2px] bg-white/10" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Optimized Video Thumbnail with lazy loading
const VideoThumbnail = ({ video, index, onClick }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const videoRef = React.useRef(null);
  const containerRef = React.useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <motion.div
      ref={containerRef}
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      data-testid={`gallery-video-${video.id}`}
      onClick={onClick}
      className="relative overflow-hidden cursor-pointer group"
    >
      <div className="aspect-[9/16] relative bg-zinc-900">
        {/* Loading skeleton */}
        {!isLoaded && (
          <div className="absolute inset-0 bg-zinc-800 animate-pulse">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-zinc-700/50 to-transparent skeleton-shimmer" />
          </div>
        )}
        {isInView && (
          <video
            ref={videoRef}
            src={video.src}
            muted
            loop
            playsInline
            preload="metadata"
            onLoadedData={() => setIsLoaded(true)}
            className={`w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition-all duration-500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
            onMouseEnter={(e) => e.target.play()}
            onMouseLeave={(e) => { e.target.pause(); e.target.currentTime = 0; }}
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
      </div>
      
      {/* Play Button */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-16 h-16 bg-white/20 backdrop-blur-sm flex items-center justify-center rounded-full group-hover:bg-[#E50914] group-hover:scale-110 transition-all duration-300">
          <Play className="w-6 h-6 ml-1" fill="white" />
        </div>
      </div>
    </motion.div>
  );
};

// Optimized Image Thumbnail with lazy loading
const ImageThumbnail = ({ item, index, onClick }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const containerRef = React.useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <motion.div
      ref={containerRef}
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.05 }}
      data-testid={`gallery-image-${item.id}`}
      onClick={onClick}
      className={`${item.span} relative overflow-hidden cursor-pointer group`}
    >
      <div className="aspect-[4/3] md:aspect-auto md:h-full w-full bg-zinc-900">
        {/* Loading skeleton */}
        {!isLoaded && (
          <div className="absolute inset-0 bg-zinc-800 animate-pulse">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-zinc-700/50 to-transparent skeleton-shimmer" />
          </div>
        )}
        {isInView && (
          <img 
            src={item.src} 
            alt={item.title}
            loading="lazy"
            onLoad={() => setIsLoaded(true)}
            className={`w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
          />
        )}
      </div>
    </motion.div>
  );
};

// Gallery Section
const Gallery = () => {
  const [activeTab, setActiveTab] = useState("videos");
  const [lightbox, setLightbox] = useState(null);
  const [videoModal, setVideoModal] = useState(null);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 px-6 md:px-12 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between mb-12"
        >
          <div>
            <p className="font-dm text-[#E50914] uppercase tracking-[0.3em] mb-4">
              Portfolio
            </p>
            <h2 className="font-garet text-4xl md:text-6xl lg:text-7xl font-bold italic uppercase tracking-tight">
              <span className="text-stroke">OUR</span> WORK
            </h2>
          </div>

          <div className="flex gap-4 mt-6 md:mt-0">
            <button
              data-testid="gallery-tab-videos"
              onClick={() => setActiveTab("videos")}
              className={`flex items-center gap-2 px-6 py-3 font-dm font-medium uppercase tracking-wider text-sm transition-all duration-300 rounded-full ${
                activeTab === "videos"
                  ? "bg-white text-black"
                  : "bg-transparent border border-white/20 text-white/60 hover:border-white hover:text-white"
              }`}
            >
              <Video size={16} />
              Videos
            </button>
            <button
              data-testid="gallery-tab-photos"
              onClick={() => setActiveTab("photos")}
              className={`flex items-center gap-2 px-6 py-3 font-dm font-medium uppercase tracking-wider text-sm transition-all duration-300 rounded-full ${
                activeTab === "photos"
                  ? "bg-white text-black"
                  : "bg-transparent border border-white/20 text-white/60 hover:border-white hover:text-white"
              }`}
            >
              <ImageIcon size={16} />
              Photos
            </button>
          </div>
        </motion.div>

        <AnimatePresence mode="wait">
          {/* Videos Grid */}
          {activeTab === "videos" && (
            <motion.div
              key="videos"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
            >
              {galleryVideos.map((video, index) => (
                <VideoThumbnail key={video.id} video={video} index={index} onClick={() => setVideoModal(video)} />
              ))}
            </motion.div>
          )}

          {/* Photos Grid */}
          {activeTab === "photos" && (
            <motion.div
              key="photos"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
              className="gallery-grid"
            >
              {galleryImages.map((item, index) => (
                <ImageThumbnail key={item.id} item={item} index={index} onClick={() => setLightbox(item)} />
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* Image Lightbox */}
      <AnimatePresence>
        {lightbox && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            data-testid="lightbox"
            className="fixed inset-0 z-50 flex items-center justify-center lightbox-overlay bg-black/95"
            onClick={() => setLightbox(null)}
          >
            <button data-testid="lightbox-close" className="absolute top-6 right-6 p-2 text-white/60 hover:text-white transition-colors" onClick={() => setLightbox(null)}>
              <X size={32} />
            </button>
            <motion.img
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              src={lightbox.src}
              alt={lightbox.title}
              className="max-w-[90vw] max-h-[85vh] object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Video Modal - HTML5 Player */}
      <AnimatePresence>
        {videoModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            data-testid="video-modal"
            className="fixed inset-0 z-50 flex items-center justify-center lightbox-overlay bg-black/95"
            onClick={() => setVideoModal(null)}
          >
            <button data-testid="video-modal-close" className="absolute top-6 right-6 p-2 text-white/60 hover:text-white transition-colors z-10" onClick={() => setVideoModal(null)}>
              <X size={32} />
            </button>
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="w-full max-w-4xl"
              onClick={(e) => e.stopPropagation()}
            >
              <video
                src={videoModal.src}
                controls
                autoPlay
                className="w-full max-h-[85vh] rounded-lg"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

// Team Section
const Team = () => {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="py-24 md:py-32 px-6 md:px-12 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-dm text-[#E50914] uppercase tracking-[0.3em] mb-4">
              Our Team
            </p>
            <h2 className="font-garet text-4xl md:text-6xl font-bold italic uppercase tracking-tight mb-6">
              <span className="text-stroke">CREATIVE</span> SPECIALISTS
            </h2>
            <p className="font-dm text-white/50 leading-relaxed">
              A curated group of professionals selected not just for skill — but for alignment in quality, discipline, and client service.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid grid-cols-2 gap-4"
          >
            {teamRoles.map((role, index) => (
              <div
                key={role}
                className="flex items-center gap-3 p-4 bg-white/5 border border-white/5"
              >
                <CheckCircle className="w-5 h-5 text-[#E50914] shrink-0" />
                <span className="font-dm text-sm text-white/70">{role}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Clients Marquee
const Clients = () => {
  return (
    <section
      data-testid="clients-section"
      className="py-16 bg-[#050505] border-y border-white/5 overflow-hidden"
    >
      <div className="flex animate-marquee whitespace-nowrap">
        {[...clients, ...clients].map((client, index) => (
          <span
            key={index}
            className="font-garet text-6xl md:text-8xl font-bold italic uppercase mx-8 text-stroke"
          >
            {client}
          </span>
        ))}
      </div>
    </section>
  );
};

// Contact Section
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    serviceType: "",
    message: "",
    budget: "",
    timeline: ""
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const submitData = {
        name: formData.name,
        email: formData.email,
        message: `Phone: ${formData.phone}\nService: ${formData.serviceType}\nBudget: ${formData.budget}\nTimeline: ${formData.timeline}\n\nProject Details:\n${formData.message}`
      };
      await axios.post(`${API}/contact`, submitData);
      setSuccess(true);
      setFormData({ name: "", email: "", phone: "", serviceType: "", message: "", budget: "", timeline: "" });
      setTimeout(() => setSuccess(false), 5000);
    } catch (err) {
      setError("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 md:py-32 px-6 md:px-12 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-dm text-[#E50914] uppercase tracking-[0.3em] mb-4">
              Get In Touch
            </p>
            <h2 className="font-garet text-4xl md:text-6xl lg:text-7xl font-bold italic uppercase tracking-tight mb-6">
              <span className="text-stroke">LET'S</span> COLLABORATE
            </h2>
            <p className="font-dm text-white/50 text-lg mb-8">
              Ready to elevate your brand's visual identity? Tell us about your project — our team will connect with you shortly.
            </p>

            <div className="space-y-4 mb-8">
              <a href="tel:7185939493" data-testid="contact-phone" className="flex items-center gap-4 text-white/60 hover:text-white transition-colors group">
                <div className="w-12 h-12 bg-white/5 flex items-center justify-center group-hover:bg-[#E50914] transition-colors">
                  <Phone size={20} />
                </div>
                <span className="font-dm">718-593-9493</span>
              </a>
              <a href="mailto:admin@bvcreativegroup.com" data-testid="contact-email" className="flex items-center gap-4 text-white/60 hover:text-white transition-colors group">
                <div className="w-12 h-12 bg-white/5 flex items-center justify-center group-hover:bg-[#E50914] transition-colors">
                  <Mail size={20} />
                </div>
                <span className="font-dm">admin@bvcreativegroup.com</span>
              </a>
              <div className="flex items-center gap-4 text-white/60 hover:text-white transition-colors group cursor-pointer">
                <div className="w-12 h-12 bg-white/5 flex items-center justify-center group-hover:bg-[#E50914] transition-colors">
                  <MapPin size={20} />
                </div>
                <span className="font-dm">Queens, New York</span>
              </div>
            </div>

            <div className="flex gap-4">
              <button
                onClick={() => window.open("https://www.facebook.com/bvcreativegroup", "_blank", "noopener,noreferrer")}
                data-testid="social-facebook"
                className="w-12 h-12 bg-white/5 flex items-center justify-center hover:bg-[#E50914] transition-colors cursor-pointer"
              >
                <Facebook size={20} />
              </button>
              <button
                onClick={() => window.open("https://www.instagram.com/bvcreativegroup/", "_blank", "noopener,noreferrer")}
                data-testid="social-instagram"
                className="w-12 h-12 bg-white/5 flex items-center justify-center hover:bg-[#E50914] transition-colors cursor-pointer"
              >
                <Instagram size={20} />
              </button>
              <button
                onClick={() => window.open("https://www.tiktok.com/@bvcreativegroup", "_blank", "noopener,noreferrer")}
                data-testid="social-tiktok"
                className="w-12 h-12 bg-white/5 flex items-center justify-center hover:bg-[#E50914] transition-colors cursor-pointer"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                </svg>
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div className="input-line">
                  <input
                    type="text"
                    placeholder="Your Name *"
                    data-testid="contact-name-input"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none py-4 text-white placeholder:text-white/30 transition-all duration-300 font-dm"
                  />
                </div>
                <div className="input-line">
                  <input
                    type="tel"
                    placeholder="Phone"
                    data-testid="contact-phone-input"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none py-4 text-white placeholder:text-white/30 transition-all duration-300 font-dm"
                  />
                </div>
              </div>

              <div className="input-line">
                <input
                  type="email"
                  placeholder="Email Address *"
                  data-testid="contact-email-input"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none py-4 text-white placeholder:text-white/30 transition-all duration-300 font-dm"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="input-line">
                  <select
                    data-testid="contact-service-input"
                    value={formData.serviceType}
                    onChange={(e) => setFormData({ ...formData, serviceType: e.target.value })}
                    className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none py-4 text-white transition-all duration-300 font-dm appearance-none cursor-pointer"
                  >
                    <option value="" className="bg-[#050505]">Type of Service</option>
                    <option value="Video Production" className="bg-[#050505]">Video Production</option>
                    <option value="Photography" className="bg-[#050505]">Photography</option>
                    <option value="Creative Design" className="bg-[#050505]">Creative Design</option>
                    <option value="Social Media" className="bg-[#050505]">Social Media Management</option>
                    <option value="Post-Production" className="bg-[#050505]">Post-Production</option>
                    <option value="Full Package" className="bg-[#050505]">Full Package</option>
                  </select>
                </div>
                <div className="input-line">
                  <select
                    data-testid="contact-budget-input"
                    value={formData.budget}
                    onChange={(e) => setFormData({ ...formData, budget: e.target.value })}
                    className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none py-4 text-white transition-all duration-300 font-dm appearance-none cursor-pointer"
                  >
                    <option value="" className="bg-[#050505]">Budget Range</option>
                    <option value="Under $5k" className="bg-[#050505]">Under $5,000</option>
                    <option value="$5k-$15k" className="bg-[#050505]">$5,000 - $15,000</option>
                    <option value="$15k-$50k" className="bg-[#050505]">$15,000 - $50,000</option>
                    <option value="$50k+" className="bg-[#050505]">$50,000+</option>
                  </select>
                </div>
              </div>

              <div className="input-line">
                <input
                  type="text"
                  placeholder="Timeline (e.g., 2 weeks, 1 month)"
                  data-testid="contact-timeline-input"
                  value={formData.timeline}
                  onChange={(e) => setFormData({ ...formData, timeline: e.target.value })}
                  className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none py-4 text-white placeholder:text-white/30 transition-all duration-300 font-dm"
                />
              </div>

              <div className="input-line">
                <textarea
                  placeholder="Project Details *"
                  data-testid="contact-message-input"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  required
                  rows={4}
                  className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none py-4 text-white placeholder:text-white/30 transition-all duration-300 font-dm resize-none"
                />
              </div>

              {error && <p className="text-red-500 font-dm text-sm">{error}</p>}

              {success && (
                <motion.p
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="text-green-500 font-dm text-sm"
                >
                  Message sent successfully! We'll get back to you shortly.
                </motion.p>
              )}

              <button
                type="submit"
                data-testid="contact-submit"
                disabled={loading}
                className="btn-primary bg-white text-black px-8 py-4 font-dm font-bold uppercase tracking-widest hover:text-white transition-colors duration-300 rounded-full flex items-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed w-full justify-center"
              >
                {loading ? "Sending..." : "Submit Inquiry"}
                <ArrowRight size={18} />
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="py-8 px-6 md:px-12 bg-[#050505] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <img 
          src={LOGO_URL} 
          alt="BV Creative Group" 
          className="h-8 w-auto brightness-0 invert"
        />
        <p className="font-dm text-white/40 text-sm">
          © {new Date().getFullYear()} BV Creative Group. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

// Main Home Page
const Home = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#050505]">
      <Navigation isOpen={mobileMenuOpen} setIsOpen={setMobileMenuOpen} />
      <Hero />
      <About />
      <Services />
      <Process />
      <Gallery />
      <Team />
      <Clients />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
